import { render, staticRenderFns } from "./litenghui_print_label.vue?vue&type=template&id=8cab0862&scoped=true&"
import script from "./litenghui_print_label.vue?vue&type=script&lang=js&"
export * from "./litenghui_print_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cab0862",
  null
  
)

export default component.exports